import { RootState } from '@store/store';
import { useSelector } from 'react-redux';

function useItemQuantity(itemId: string) {
  const { orderLines } = useSelector((root: RootState) => root.item);

  return orderLines.find((orderLine) => orderLine.shopItemId === itemId)
    ?.quantity || 0;
}

export default useItemQuantity;
